import {Player, Team} from '../types'

export function GetExclucsionList(player:Player){
    const list : string[] = [];
    if(player.BannedHeroes){
        player.BannedHeroes.map((h) => list.push(h));
    }
    if(!player.Draft) return list;
    player.Draft.map((h) => list.push(h.Name));
    return list;
}   


export function GetDefaultPlayers() : Player[] {
    let playerList : Player[] = [];

    const p1 : Player = {
        Number : 1,
        Name : "",
        Team : Team.Blue,
        BannedHeroes:[]
    }
    playerList.push(p1);

    const p2 : Player = {
        Number : 2,
        Name : "",
        Team : Team.Blue,
        BannedHeroes:[]
    }
    playerList.push(p2);

    const p3 : Player = {
        Number : 3,
        Name : "",
        Team : Team.Red,
        BannedHeroes:[]
    }
    playerList.push(p3);

    const p4 : Player = {
        Number : 4,
        Name : "",
        Team : Team.Red,
        BannedHeroes:[]
    }
    playerList.push(p4);

    return playerList;
}
